import axios from "axios";

const BASE = "https://api.medstown.com/local-delivery/admin";

export const ldAdminApi = {
  listConfigs: async () => (await axios.get(`${BASE}/configs`)).data,
  upsertConfig: async (body) => (await axios.post(`${BASE}/configs`, body)).data,
  deleteConfig: async (id) => (await axios.delete(`${BASE}/configs/${id}`)).data,
  liveOps: async (params = {}) =>
    (await axios.get(`${BASE}/bookings`, { params })).data,
  bookingDetail: async (id) => (await axios.get(`${BASE}/bookings/${id}`)).data,
  deleteBooking: async (id) =>
    (await axios.delete(`${BASE}/bookings/${id}`)).data,
  notifications: async (params = {}) =>
    (await axios.get(`${BASE}/notifications`, { params })).data,
};
